// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__hRMTn","main":"layout_main__CCH63"};